import React from 'react';
import moment from 'moment';
import { getColorForName } from 'Helpers/colorPalette';

export default (props) => {
  const {
    message,
    publisherId,
    timestamp,
    name,
    msgId,
    feedbackDetails: { reporterMobile, type }
  } = props;

  const isReporter = publisherId.includes(reporterMobile);
  const nameColor = getColorForName(name);

  return (
    <div key={ msgId }>
      <div className={ isReporter ? 'reporter' : 'reported' }>
        <p>
          {type === 'groupchat' && (
            <div
              className='report-user-name'
              style={ { color: nameColor } }
            >
              { name }
            </div>
          )}
          <div>{message}</div>
          <small>{moment(parseInt(timestamp)).format('h:mm A')}</small>
        </p>
      </div>
    </div>
  );
};
